/**
 * @store 门户 企业 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * 热门专家
     * @param _
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    async queryRecommend(_, data) {
      return await api.post(`/api/expert/recommend`, data);
    },
    /**
     * 专家筛选条件
     * @param _
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    async queryFilter(_, data) {
      return await api.post(`/api/expert/filterList`, data);
    },
    /**
     * 专家列表
     * @param _
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    async queryList(_, data) {
      return await api.post(`/api/expert/lists`, data);
    },
    /**
     * 专家详情
     * @param _
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    async queryDetail(_, data) {
      return await api.post(`/api/expert/detail`, data);
    },
  },
}
